import React from 'react';

export interface ExclamationMarkIconProps {
  width?: number;
  height?: number;
  outline?: string;
  exclamationColor?: string;
  fill?: string;
}

const ExclamationMarkIcon: React.FC<ExclamationMarkIconProps> = ({
  width = 24,
  height = 24,
  outline = 'black',
  exclamationColor = 'black',
  fill = '#fff'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Circular background */}
      <circle
        cx="6.5"
        cy="6.5"
        r="6.5"
        fill={fill}
      />
      <path
        d="M6.5 0C2.9055 0 0 2.925 0 6.5C0 8.22391 0.684819 9.87721 1.90381 11.0962C2.50739 11.6998 3.22394 12.1786 4.01256 12.5052C4.80117 12.8319 5.64641 13 6.5 13C8.22391 13 9.87721 12.3152 11.0962 11.0962C12.3152 9.87721 13 8.22391 13 6.5C13 5.64641 12.8319 4.80117 12.5052 4.01256C12.1786 3.22394 11.6998 2.50739 11.0962 1.90381C10.4926 1.30023 9.77606 0.821439 8.98744 0.494783C8.19883 0.168127 7.35359 0 6.5 0ZM6.5 11.7C5.12087 11.7 3.79823 11.1521 2.82304 10.177C1.84786 9.20177 1.3 7.87913 1.3 6.5C1.3 5.12087 1.84786 3.79823 2.82304 2.82304C3.79823 1.84786 5.12087 1.3 6.5 1.3C7.87913 1.3 9.20177 1.84786 10.177 2.82304C11.1521 3.79823 11.7 5.12087 11.7 6.5C11.7 7.87913 11.1521 9.20177 10.177 10.177C9.20177 11.1521 7.87913 11.7 6.5 11.7Z"
        fill={outline}
      />

      {/* Exclamation mark */}
      <path
        d="M5.85 8.45H7.15V9.75H5.85V8.45ZM5.85 3.25H7.15V7.15H5.85V3.25Z"
        fill={exclamationColor}
      />
    </svg>
  );
};

export default ExclamationMarkIcon;
